export enum SECTION_NAMES {
  PICTURE_VIEW = 'picture_view',
  OPTIONS_MENU = 'options_menu',
  PERSONALIZE = 'personalize',
  ZOOM = 'zoom',
  QUALITY_ALERT_MODAL = 'quality_alert_modal',
  MULTIPLE_PURCHASE_MODAL = 'multiple_purchase_modal',
  DELETE_PRODUCT_MODAL = 'delete_product_modal',
  EMPTY_IMAGES_MODAL = 'empty_images_modal',
  UPLOAD_TO_CART_MODAL = 'upload_to_cart_modal',
  ERROR_CART_MODAL = 'error_cart_modal',
  SAVE_CHANGES_MODAL = 'save_changes_modal',
  APPLY_ALL_MODAL = 'apply_all_modal',
  MODAL_UP_SELLING_MODAL = 'modal_up_selling_modal',
  UPLOAD_MULTI_SOURCE_MODAL = 'upload_multi_source_modal',
  PRIVACY_POLICY_MODAL = 'privacy_policy_modal',
  CUT_ALERT_MODAL = 'cut_alert_modal',
  CUT_CONFIRMATION_ALERT_MODAL = 'cut_confirmation_alert_modal',
  CONFIGURATION_STEPS_MODAL = 'configuration_steps_modal',
  EXIT_PROJECT_MODAL = 'exit_project_modal',
  DELETE_ALL_MODAL = 'delete_all_modal',
  PRODUCT_NOT_AVAILABLE_MODAL = 'product_not_available_modal',
  CONFIGURATION_STEPS_MOBILE_VIEW = 'configuration_steps_mobile_view',
  ADJUST_CROPS_VIEW = 'adjust_crops_view',
  EDITOR_VIEW = 'editor_view',
  PRODUCT_EDITOR_VIEW = 'product_editor_view',
  DRAWER = 'drawer',
}
